import React, { useState } from 'react';
import LoadingButton from 'Components/LoadingButton';
import Icon, { IconTypeNames } from "Components/Icon";
import { endingIn } from 'Utils/Utils';
import { useHistory, useLocation } from "react-router-dom";
import { Routes } from 'Utils/Constants';
import useVipApiFetcher, { handleError, handleResponse, handleOkResponse } from 'Utils/Hooks/useVipApiFetcher';
import useMode, { MODE } from "Utils/Hooks/useMode";
import useTransactionInitiated from "Utils/Hooks/useTransactionInitiated";
import Header from "Components/Header/Header";
import useFundType, { FUNDTYPE } from "Utils/Hooks/useFundType";

import "./DeleteAccount.scss";

const DeleteAccount = () => {

  const fundType = useFundType();
  const history = useHistory();
  const location = useLocation();
  const vipApi = useVipApiFetcher();
  const mode = useMode();
  const { transactionInitiated } = useTransactionInitiated();

  const isDepositMode = mode === MODE.deposit;

  const { account, count } = { ...location.state }
  const [submitted, setSubmitted] = useState(false);

  const canDelete = count > 1;

  const onDeleteBank = async () => {
    setSubmitted(true);
    const body = {
      bankName: account.bankName,
      routingNumber: account.routingNumber,
      accountNumber: account.accountNumber,
      maskedAccountNumber: account.maskedAccountNumber
    };

    vipApi.fetch("/api/bank", "DELETE", body)
      .then(response => handleResponse(history, response))
      .then(response =>
        handleOkResponse({
          history,
          response,
          title: fundType === FUNDTYPE.netspend ?  "Netspend/Playcard Account Deleted" : "Bank Account Deleted",
          message: `Your ${response.body.bankName} account${endingIn(response.body.bankAccountNumber)} has been successfully deleted.`,
          customButtons: transactionInitiated ? [{
            label: 'ADD NEW FUNDING SOURCE',
            route: Routes.ADD_ACCOUNT
          },{
            label: `COMPLETE ${(isDepositMode) ? 'DEPOSIT' : 'WITHDRAW'}`,
            route: (isDepositMode) ? Routes.DEPOSIT : Routes.WITHDRAW,
          }] : undefined,
          errorCustomButtons: transactionInitiated ? [{
            label: 'TRY AGAIN',
            route: Routes.MY_ACCOUNTS
          },{
            label: `COMPLETE ${(isDepositMode) ? 'DEPOSIT' : 'WITHDRAW'}`,
            route: (isDepositMode) ? Routes.DEPOSIT : Routes.WITHDRAW,
          }] : undefined,
        })
      )
      .catch(error => { handleError(error, history); });
  };

  const onCancel = () => {
    history.goBack();
  }

  const submitButton = (submitted) ?
    <LoadingButton /> :
    <button
      type="button"
      className="submit-button click-delete-account"
      onClick={onDeleteBank}
    >
      YES
    </button>;

  return (
    <>
      <Header back={false}></Header>
      <div className="response delete-account">
        {!canDelete && <Icon {...{ typeName: IconTypeNames.error }} />}
        <div className="response-header">Delete Account</div>
        <div className="response-message">
          Are you sure you want to delete your {account.bankName?.toUpperCase()} account{endingIn(account.bankAccountNumber?.replaceAll("*", ""))}?
        </div>
        {submitButton}
        <button
          type="button"
          className="submit-button click-delete-account-cancel"
          onClick={onCancel}
        >
          CANCEL
          </button>
      </div>
    </>
  );
}

export default DeleteAccount;